module.exports = __webpack_public_path__ + "static/media/you-belong.40e10320.jpg";